import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";
import { AddBrandResponse } from "../types/add-brand-types";

const useBrandDetailsApi = () => {
  const { get } = useHttpAdapter();

  const getBrandDetails = useCallback(
    async (brandId: string): Promise<AddBrandResponse | null> => {
      try {
        const url = `/brand/${brandId}`;
        const response = await get<AddBrandResponse>(url);
        return response.data;
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    [get]
  );

  return { getBrandDetails };
};

export default useBrandDetailsApi;
